var map = {
	"./app.js": "RL/B",
	"./goods.js": "VKiZ",
	"./user.js": "zN38"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f0G";


//////////////////
// WEBPACK FOOTER
// ./src/vuex/modules \.js$
// module id = 9f0G
// module chunks = 90